/* @flow */
import React from 'react';
import { IndexRoute, Route, IndexRedirect } from 'react-router';

import ActivitiesClassView from 'groups/components/ActivitiesClassView.jsx';
import ActivitiesCreateView from 'groups/components/ActivitiesCreateView.jsx';
import AdminVerificationPage from 'organizations/containers/AdminVerificationPage.jsx';
import AnnouncementsConversationView from 'chat/components/AnnouncementsConversationView.jsx';
import ChatDefaultView from 'chat/components/ChatDefaultView.jsx';
import ConversationView from 'chat/components/ConversationView.jsx';
import GroupContainer from 'groups/containers/GroupContainer.jsx';
import GroupMembersTabListView from 'groups/components/GroupMembersTabListView.jsx';
import GroupMessagesContainer from 'groups/containers/GroupMessagesContainer.jsx';
import GroupsIndexHandler from 'groups/components/GroupsIndexHandler.jsx';
import GroupsView from 'groups/components/GroupsView.jsx';
import SchoolStatsTab from 'groups/components/SchoolStatsTab.jsx';

export default (
  <Route path="/classes(/)" component={GroupsView} onEnter={GroupsView.onEnter}>
    <Route path=":groupCode" component={GroupContainer} onEnter={GroupContainer.onEnter}>
      <IndexRedirect to="messages" />
      <Route
        path="messages"
        component={GroupMessagesContainer}
        onEnter={GroupMessagesContainer.onEnter}>
        <Route
          path="new(/:memberId)"
          component={ConversationView}
          onEnter={ConversationView.onEnter}
          onLeave={ConversationView.onLeaveNewChat}
        />
        <Route
          path="announcements/:role"
          component={AnnouncementsConversationView}
        />
        <Route
          path=":chatId"
          component={ConversationView}
          onEnter={ConversationView.onEnter}
        />
        <IndexRoute component={ChatDefaultView} onEnter={ChatDefaultView.onEnter} />
      </Route>
      <Route path="settings" />
      <Route path="invite" />
      <Route path="people" component={GroupMembersTabListView} />
      <Route path="activities" component={ActivitiesClassView} />
      <Route path="activities/new" component={ActivitiesCreateView} />
      <Route path="verify" component={AdminVerificationPage} />
      <Route path="statistics" component={SchoolStatsTab} />
    </Route>
    <IndexRoute component={GroupsIndexHandler} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/groups/routes.js